import { Component, OnInit } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { ActivatedRoute, Router } from "@angular/router";
import { LocationInfo } from "../../models/locationInfo";
import { Client } from "../../models/client";
import { isNullOrUndefined } from "util";

@Component({
  selector: 'app-location-size-guide',
  templateUrl: './location-size-guide.component.html',
  styleUrls: ['./location-size-guide.component.scss']
})
export class LocationSizeGuideComponent implements OnInit {

  key: string;
  locKey: string;
  unitSizes: any;
  locationData: LocationInfo;
  clientData: Client;
  showSaveButton = false;

  constructor(
    public afService: FirebaseService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.key = params['key'];
      this.locKey = params['locKey'];

      this.afService.getClientInfo(this.key).subscribe((clientData) => {
        this.clientData = clientData;

        this.afService.getLocationInfo(this.key, this.locKey).subscribe((locationData) => {
          this.locationData = locationData;

          if (isNullOrUndefined(this.locationData.sizeGuide)) {
            if (!isNullOrUndefined(this.clientData.pages.sizeGuide)) {
              this.locationData.sizeGuide = {
                title: this.clientData.pages.sizeGuide.title,
                body: this.clientData.pages.sizeGuide.body,
                hideButtons: this.clientData.pages.sizeGuide.hideButtons,
                sizes: []
              };
            }
            else {
              this.locationData.sizeGuide = {
                title: 'What Size Do I Need?',
                body: 'Let us help you select the right unit for all your storage needs! Our Size Guide will help you easily determine the perfect size. Don’t hesitate to contact our storage professionals to answer any of your storage questions along the way.',
                hideButtons: false,
                sizes: []
              };
            }
          }

          if (!this.clientData.suppressGetUnits) {
            this.afService.getUnitSizes(this.clientData.code, this.locKey).map(unitSizes => {
              let tmp = [];
              for (let index in unitSizes) {
                if (unitSizes.hasOwnProperty(index)) {
                  tmp.push({ label: `${ unitSizes[index].length }x${ unitSizes[index].width }`, value: unitSizes[index] });
                }
              }
              return tmp;
            }).subscribe(unitSizes => this.unitSizes = unitSizes);
          }
          else {
            this.unitSizes = [];
          }
        });
      });
    });
  }

  copyFromPageSettings() {
    let pageSizesCopy = this.clientData.pages.sizeGuide.sizes;
    for (let copy of pageSizesCopy) {
      console.log(copy)
      this.locationData.sizeGuide.sizes.push(copy);
      if (!isNullOrUndefined(copy.name2) && copy.name2 !== '') {
        this.locationData.sizeGuide.sizes.push({ shortName: 'Copied from alt name', name: copy.name2, squareFeet: copy.squareFeet2 });
      }
    }
    console.log(this.locationData.sizeGuide.sizes)
    this.showSaveButton = true;
  }

  updateShowButtons(e) {
    console.log(e);
    this.locationData.sizeGuide.hideButtons = e.checked;
    this.savelocationData();
  }

  savelocationData() {
    for (let tmp of this.locationData.sizeGuide.sizes) {
      delete tmp._$visited;
    }
    this.afService.updateLocation(this.clientData, this.locationData).then(() => {
      this.afService.openSnackBar('Location Settings Updated Successfully');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/location-size-guide/location-size-guide.component.ts